<template>
  <div class="w-full h-full overflow-y-auto [border-radius:calc(25px-2vh)]">
    <div class="mb-[16px] text-center">
      <h1 class="text-3xl md:text-4xl font-extrabold text-[#274154]">
        Tüm Hizmetlerimiz
      </h1>
      <p class="text-[#274154] mt-2 text-lg mb-[5vh]">
        İhtiyacınız olan lojistik ve gümrük işlemlerini hızla gerçekleştirin.
      </p>
    </div>

    <div
      class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8 mt-8"
    >
      <div
        class="service-card group backdrop-blur-lg bg-white/80 mb-4 lg:mb-0 rounded-2xl shadow-xl hover:shadow-2xl transition duration-300 transform hover:-translate-y-1 hover:bg-white border-b-4 border-blue-500"
      >
        <div
          class="flex bg-blue-500 p-2 rounded-lg transform items-center w-fit -mt-6 left-1/2 -translate-x-1/2 w-fit absolute whitespace-nowrap"
        >
          <h3 class="text-xl font-bold text-white">Transit Tescil İşlemleri</h3>
        </div>
        <ul class="space-y-3 text-sm pt-4 p-6 mt-6">
          <li class="flex items-start">
            • İthalat ve İhracat NCTS / TIR Tescil
          </li>
          <li class="flex items-start">• Transit Tescil ve Sevk İşlemleri</li>
          <li class="flex items-start">• İskele İşlemleri</li>
        </ul>
      </div>

      <div
        class="service-card group backdrop-blur-lg bg-white/80 mb-4 lg:mb-0 rounded-2xl shadow-xl hover:shadow-2xl transition duration-300 transform hover:-translate-y-1 hover:bg-white border-b-4 border-red-500"
      >
        <div
          class="flex bg-red-500 p-2 rounded-lg transform items-center w-fit -mt-6 left-1/2 -translate-x-1/2 w-fit absolute whitespace-nowrap"
        >
          <h3 class="text-xl font-bold text-white">Dilekçeli İşlemler</h3>
        </div>
        <ul class="space-y-3 text-sm pt-4 p-6 mt-6">
          <li class="flex items-start">• İdarelere Yazılı Başvuru</li>
          <li class="flex items-start">• Eksiklik/Fazlalık Takibatı</li>
          <li class="flex items-start">• Ceza Kararı Takip İşlemleri</li>
          <li class="flex items-start">• Beyan Düzeltme</li>
          <li class="flex items-start">• Tasfiye CIF %1 İşlemleri</li>
        </ul>
      </div>

      <div
        class="service-card group backdrop-blur-lg bg-white/80 mb-4 lg:mb-0 rounded-2xl shadow-xl hover:shadow-2xl transition duration-300 transform hover:-translate-y-1 hover:bg-white border-b-4 border-green-500"
      >
        <div
          class="flex bg-green-500 p-2 rounded-lg transform items-center w-fit -mt-6 left-1/2 -translate-x-1/2 w-fit absolute whitespace-nowrap"
        >
          <h3 class="text-xl font-bold text-white">Özet Beyan İşlemleri</h3>
        </div>
        <ul class="space-y-3 text-sm pt-4 p-6 mt-6">
          <li class="flex items-start">• Özet Beyan Yazım İşlemleri</li>
          <li class="flex items-start">• Ambar Onay İşlemleri</li>
          <li class="flex items-start">• Risk Analizi Kaynaklı İşlemler</li>
        </ul>
      </div>

      <div
        class="service-card group backdrop-blur-lg bg-white/80 rounded-2xl shadow-xl hover:shadow-2xl transition duration-300 transform hover:-translate-y-1 hover:bg-white border-b-4 border-purple-500"
      >
        <div
          class="flex bg-purple-500 p-2 rounded-lg transform items-center w-fit -mt-6 left-1/2 -translate-x-1/2 w-fit absolute whitespace-nowrap"
        >
          <h3 class="text-xl font-bold text-white">Transit Beyannamesi</h3>
        </div>
        <ul class="space-y-3 text-sm pt-4 p-6 mt-6">
          <li class="flex items-start">• NCTS TR Belgesi Yazımı</li>
          <li class="flex items-start">• NCTS T1 Belgesi Yazımı</li>
          <li class="flex items-start">• NCTS T2 Belgesi Yazımı</li>
          <li class="flex items-start">• Kapsamlı Teminat Hizmeti</li>
          <li class="flex items-start">• TIR Karnesi Yazım İşlemleri</li>
          <li class="flex items-start">• e-TIR</li>
        </ul>
      </div>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 mt-10 gap-y-10">
      <div
        class="service-card group backdrop-blur-lg bg-white/80 rounded-2xl shadow-xl hover:shadow-2xl transition duration-300 transform hover:-translate-y-1 hover:bg-white border-b-4 border-orange-500"
      >
        <div
          class="flex bg-orange-500 p-2 rounded-lg transform items-center w-fit -mt-6 left-1/2 -translate-x-1/2 w-fit absolute whitespace-nowrap"
        >
          <h3 class="text-xl font-bold text-white">Ordino İşlemleri</h3>
        </div>
        <ul class="space-y-3 text-sm pt-4 p-6 mt-6">
          <li class="flex items-start">
            • Sahalar, Limanlar ve Acentelerden Ana Konşimento (MAVB) teslim
            alma
          </li>
          <li class="flex items-start">• Ofiste Ara Ordino (HAVB) Hazırlama</li>
          <li class="flex items-start">
            • Hazırlanan Evrakların Müşteri Gümrük Müşavirine Teslim Edilmesi
          </li>
        </ul>
      </div>

      <div
        class="service-card group backdrop-blur-lg bg-white/80 rounded-2xl shadow-xl hover:shadow-2xl transition duration-300 transform hover:-translate-y-1 hover:bg-white border-b-4 border-yellow-500"
      >
        <div
          class="flex bg-yellow-500 p-2 rounded-lg transform items-center w-fit -mt-6 left-1/2 -translate-x-1/2 w-fit absolute whitespace-nowrap"
        >
          <h3 class="text-xl font-bold text-white">TIR Karnesi İşlemleri</h3>
        </div>
        <ul class="space-y-3 text-sm pt-4 p-6 mt-6">
          <li class="flex items-start">
            • TIR Karnesi 6 Yaprak / Gümrük Ofislerinden Teslim Hizmeti
          </li>
          <li class="flex items-start">
            • TIR Karnesi 16 Yaprak / Gümrük Ofislerinden Teslim Hizmeti
          </li>
        </ul>
      </div>

      <div
        class="service-card group backdrop-blur-lg bg-white/80 rounded-2xl shadow-xl hover:shadow-2xl transition duration-300 transform hover:-translate-y-1 hover:bg-white border-b-4 border-cyan-500"
      >
        <div
          class="flex bg-cyan-500 p-2 rounded-lg transform items-center w-fit -mt-6 left-1/2 -translate-x-1/2 w-fit absolute whitespace-nowrap"
        >
          <h3 class="text-xl font-bold text-white">Destek ve Ek İşlemler</h3>
        </div>
        <ul class="space-y-3 text-sm pt-4 p-6 mt-6">
          <li class="flex items-start">• Refakat İşlemleri</li>
          <li class="flex items-start">
            • Kırmızı Hat Fiziki Muayene İşlemleri
          </li>
          <li class="flex items-start">• KTF Giriş-Çıkış Takip</li>
          <li class="flex items-start">• CİM Belgesi İşlemleri</li>
          <li class="flex items-start">• SEBİS Giriş/Çıkış Kayıt İşlemleri</li>
          <li class="flex items-start">
            • İç Boşaltma/Dolum için Personel Tahsisi
          </li>
          <li class="flex items-start">
            • Araç Uygunluk Belgelerinin Gümrükten Temini İşlemleri
          </li>
          <li class="flex items-start">
            • Sınır Kapıları Zirai Karantina İşlemleri
          </li>
          <li class="flex items-start">• Sınır Kapıları X-Ray İşlemleri</li>
          <li class="flex items-start">
            • Karayolu İthalat Orijinal Evrak Teslimi
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
